var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoticePrimary2020 = function SvgNoticePrimary2020(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#33A1FC",
    d: "M10 3.333A6.674 6.674 0 0 1 16.667 10 6.674 6.674 0 0 1 10 16.667 6.674 6.674 0 0 1 3.333 10 6.674 6.674 0 0 1 10 3.333m0-1.666a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 1 0 0-16.667m.833 10.833H9.167v1.667h1.666zm-1.666-1.667h1.666l.417-5h-2.5z"
  })));
};
export default SvgNoticePrimary2020;